import { render, staticRenderFns } from "./problemDes.vue?vue&type=template&id=4e6c4456&scoped=true&"
import script from "./problemDes.vue?vue&type=script&lang=js&"
export * from "./problemDes.vue?vue&type=script&lang=js&"
import style0 from "./problemDes.vue?vue&type=style&index=0&id=4e6c4456&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6c4456",
  null
  
)

export default component.exports